import { Typography } from '@mui/material';

const ContractInfinitySymbol = () => (
  <Typography component="span" variant="h4" sx={{ verticalAlign: 'middle' }}>
    ∞
  </Typography>
);

export default ContractInfinitySymbol;
